import { CRO, TOKENS_WITH_XFER_MAP } from "../../constants"
import { BigNumber } from "@ethersproject/bignumber"
import { Contract } from "ethcall"
import ERC20_ABI from "../../constants/abis/erc20.json"
import { Erc20 } from "../../../types/ethers-contracts/Erc20"
import { MulticallContract } from "../../types/ethcall"
import { getMulticallProvider } from "../../utils"
import { useActiveWeb3React } from "../../hooks"
import usePoller from "../../hooks/usePoller"
import { useState } from "react"

export function usePoolTokenBalances(): { [token: string]: BigNumber } | null {
  const { account, chainId, library } = useActiveWeb3React()
  const [balances, setBalances] = useState<{ [token: string]: BigNumber }>({})

  usePoller((): void => {
    async function pollBalances(): Promise<void> {
      if (!library || !chainId || !account) return

      const ethcallProvider = await getMulticallProvider(library, chainId)
      const tokens = Object.values(TOKENS_WITH_XFER_MAP).filter(
        ({ addresses, symbol }) => addresses[chainId] && symbol !== CRO.symbol,
      )
      const balanceCalls = tokens
        .map((t) => {
          return new Contract(
            t.addresses[chainId],
            ERC20_ABI,
          ) as MulticallContract<Erc20>
        })
        .map((c) => c.balanceOf(account))
      const balances = await ethcallProvider.all(balanceCalls, {})
      const croBalance = await library.getBalance(account)

      setBalances({
        [CRO.symbol]: croBalance,
        ...tokens.reduce(
          (acc, t, i) => ({
            ...acc,
            [t.symbol]: balances[i],
          }),
          {} as { [token: string]: BigNumber },
        ),
      })
    }
    if (account) {
      void pollBalances()
    } else {
      setBalances({})
    }
  }, 5000)

  return balances
}
